// extracted by mini-css-extract-plugin
export default {"footer":"Footer__footer___G9D2c"};